import { render, staticRenderFns } from "./ModalBlackjackRules.vue?vue&type=template&id=b4bf4a2a&scoped=true"
import script from "./ModalBlackjackRules.vue?vue&type=script&lang=js"
export * from "./ModalBlackjackRules.vue?vue&type=script&lang=js"
import style0 from "./ModalBlackjackRules.vue?vue&type=style&index=0&id=b4bf4a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf4a2a",
  null
  
)

export default component.exports